import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/pages/dashboard/components/DashboardLayout';
import JobForm from '@/pages/dashboard/jobs/components/JobForm';
import { useAuth } from '@/context/AuthContext';

function JobNew() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50">Nouvelle offre d&apos;emploi</h1>
        <p className="text-sm text-foreground-400 mt-1">
          Publiez une offre et recevez les candidatures directement sur la plateforme.
        </p>
      </div>

      <div className="max-w-3xl">
        <JobForm ownerId={user.id} onSaved={() => navigate('/dashboard/jobs')} />
      </div>
    </DashboardLayout>
  );
}

export default JobNew;